function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (n, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], t) : t((n = n || self).ReactStepWizard = {}, n.React);
}(this, function (n, r) {
  "use strict";

  var i = "default" in r ? r["default"] : r;

  function s(n) {
    return (s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (n) {
      return _typeof(n);
    } : function (n) {
      return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : _typeof(n);
    })(n);
  }

  function c(n, t) {
    for (var e = 0; e < t.length; e++) {
      var a = t[e];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
    }
  }

  function p(n, t, e) {
    return t in n ? Object.defineProperty(n, t, {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : n[t] = e, n;
  }

  function f(n) {
    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
      return n.__proto__ || Object.getPrototypeOf(n);
    })(n);
  }

  function u(n, t) {
    return (u = Object.setPrototypeOf || function (n, t) {
      return n.__proto__ = t, n;
    })(n, t);
  }

  function l(n) {
    if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }

  function t(n, t) {
    void 0 === t && (t = {});
    var e = t.insertAt;

    if (n && "undefined" != typeof document) {
      var a = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style");
      o.type = "text/css", "top" === e && a.firstChild ? a.insertBefore(o, a.firstChild) : a.appendChild(o), o.styleSheet ? o.styleSheet.cssText = n : o.appendChild(document.createTextNode(n));
    }
  }

  var d = "rsw_1z",
      h = "rsw_1M",
      m = "rsw_19",
      y = "rsw_3C",
      w = "rsw_1u";
  t("/**\n * Snippets from animate.css\n * Credit goes to https://github.com/daneden\n * github.com/daneden/animate.css\n*/\n.rsw_1z {\n  -webkit-animation-duration: .8192s;\n  animation-duration: .8192s;\n  -webkit-animation-fill-mode: backwards;\n  animation-fill-mode: backwards;\n}\n\n/** fadeInRight */\n@-webkit-keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_1M {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_1M {\n  -webkit-animation-name: rsw_1M;\n  animation-name: rsw_1M;\n}\n\n/** fadeInLeft */\n@-webkit-keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes rsw_19 {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.rsw_19 {\n  -webkit-animation-name: rsw_19;\n  animation-name: rsw_19;\n}\n\n/** fadeOutRight */\n@-webkit-keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes rsw_3C {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.rsw_3C {\n  -webkit-animation-name: rsw_3C;\n  animation-name: rsw_3C;\n}\n\n/** fadeOutLeft */\n@-webkit-keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes rsw_1u {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.rsw_1u {\n  -webkit-animation-name: rsw_1u;\n  animation-name: rsw_1u;\n}\n");
  var v = "rsw_2Y",
      o = "rsw_2f",
      b = "rsw_3G";
  t("/** Step Wizard */\n.rsw_2Y {\n    position: relative;\n}\n\n.rsw_2f {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 0;\n}\n\n.rsw_3G {\n    opacity: 1;\n    pointer-events: inherit;\n    position: relative;\n    z-index: 1;\n}\n");

  var e = function (n) {
    function a(n) {
      var o, t, e;
      return function (n, t) {
        if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, a), t = this, e = f(a).call(this, n), p(l(l(o = !e || "object" != _typeof(e) && "function" != typeof e ? l(t) : e)), "initialState", function () {
        var e = {
          activeStep: 0,
          classes: {},
          hashKeys: {}
        },
            n = "object" === ("undefined" == typeof window ? "undefined" : s(window)) ? o.getHash() : "",
            t = i.Children.toArray(o.props.children);
        t.forEach(function (n, t) {
          e.hashKeys[t] = n.props && n.props.hashKey || "step".concat(t + 1), e.hashKeys[e.hashKeys[t]] = t;
        });
        var a = o.props.initialStep - 1;
        return a && t[a] && (e.activeStep = a), o.props.isHashEnabled && n && void 0 !== e.hashKeys[n] && (e.activeStep = e.hashKeys[n]), o.props.transitions && (e.classes[e.activeStep] = o.props.transitions.intro || ""), e;
      }), p(l(l(o)), "getHash", function () {
        return decodeURI(window.location.hash).replace(/^#/, "");
      }), p(l(l(o)), "getTransitions", function () {
        return o.props.transitions || {
          enterRight: "".concat(d, " ").concat(h),
          enterLeft: "".concat(d, " ").concat(m),
          exitRight: "".concat(d, " ").concat(y),
          exitLeft: "".concat(d, " ").concat(w)
        };
      }), p(l(l(o)), "onHashChange", function () {
        var n = o.state.hashKeys[o.getHash()];
        void 0 !== n && o.setActiveStep(n);
      }), p(l(l(o)), "isInvalidStep", function (n) {
        return n < 0 || n >= o.props.children.length;
      }), p(l(l(o)), "setActiveStep", function (n) {
        var t = o.state.activeStep;
        if (t !== n) if (o.isInvalidStep(n)) console.error("".concat(n + 1, " is an invalid step"));else {
          var e = o.state.classes,
              a = o.getTransitions();
          e[n] = t < n ? (e[t] = a.exitLeft, a.enterRight) : (e[t] = a.exitRight, a.enterLeft), o.setState({
            activeStep: n,
            classes: e
          }, function () {
            o.onStepChange({
              previousStep: t + 1,
              activeStep: n + 1
            });
          });
        }
      }), p(l(l(o)), "onStepChange", function (n) {
        o.props.onStepChange(n), o.props.isHashEnabled && o.updateHash(o.state.activeStep);
      }), p(l(l(o)), "firstStep", function () {
        return o.goToStep(1);
      }), p(l(l(o)), "lastStep", function () {
        return o.goToStep(o.props.children.length);
      }), p(l(l(o)), "nextStep", function () {
        return o.setActiveStep(o.state.activeStep + 1);
      }), p(l(l(o)), "previousStep", function () {
        return o.setActiveStep(o.state.activeStep - 1);
      }), p(l(l(o)), "goToStep", function (n) {
        return o.setActiveStep(n - 1);
      }), p(l(l(o)), "updateHash", function (n) {
        window.location.hash = o.state.hashKeys[n];
      }), p(l(l(o)), "isReactComponent", function (n) {
        var t = n.type;
        return "function" == typeof t || "object" === s(t);
      }), o.state = o.initialState(), o;
    }

    var t, e, o;
    return function (n, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), t && u(n, t);
    }(a, r.PureComponent), t = a, (e = [{
      key: "componentDidMount",
      value: function value() {
        this.props.isHashEnabled && window.addEventListener("hashchange", this.onHashChange), this.props.instance(this);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.isHashEnabled && window.removeEventListener("hashchange", this.onHashChange);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            a = {
          currentStep: this.state.activeStep + 1,
          totalSteps: this.props.children.length,
          nextStep: this.nextStep,
          previousStep: this.previousStep,
          goToStep: this.goToStep,
          firstStep: this.firstStep,
          lastStep: this.lastStep
        },
            o = this.state.classes,
            n = i.Children.map(this.props.children, function (n, t) {
          return a.isActive = t === e.state.activeStep, a.transitions = o[t], !e.props.isLazyMount || e.props.isLazyMount && a.isActive ? i.createElement(S, a, e.isReactComponent(n) ? i.cloneElement(n, a) : n) : null;
        });
        return i.createElement("div", {
          className: this.props.className
        }, this.props.nav && i.cloneElement(this.props.nav, a), i.createElement("div", {
          className: v
        }, n));
      }
    }]) && c(t.prototype, e), o && c(t, o), a;
  }();

  e.defaultProps = {
    children: [],
    className: null,
    initialStep: 1,
    instance: function instance() {},
    isHashEnabled: !1,
    isLazyMount: !1,
    nav: null,
    onStepChange: function onStepChange() {},
    transitions: void 0
  };

  var S = function S(n) {
    var t = n.children,
        e = n.isActive,
        a = n.transitions;
    return i.createElement("div", {
      className: "".concat(o, " ").concat(a, " ").concat(e ? b : "").trim()
    }, t);
  };

  process.env.NODE_ENV, S.defaultProps = {
    children: [],
    isActive: !1,
    transitions: ""
  }, n.Step = S, n["default"] = e, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});